import { useContext } from "react";

import { OverviewContext } from "../context";

export const useOverviewContext = () => {
  const context = useContext(OverviewContext);

  if (!context) {
    throw new Error(
      "useOverviewContext can only be used inside OverviewProvider",
    );
  }

  return context;
};
